export { renderEmptySwatch_unstable as renderEmptySwatch } from '@fluentui/react-swatch-picker';
